import { createStore as reduxCreateStore, applyMiddleware, combineReducers } from 'redux'

// middleware
const middlewares = []
import logger from 'redux-logger'
if (process.env.NODE_ENV !== 'production') {
  middlewares.push(logger)
}
import { thunk } from 'redux-thunk'
middlewares.push(thunk)

// reducers
import delayCertificateReducer from './reducers/DelayCertificateReducer'
import announcementReducer from './reducers/AnnouncementReducer'
import trainPositionReducer from './reducers/TrainPositionReducer'
import stationReducer from './reducers/StationReducer'
import stationViewReducer from './reducers/stationViewReducer'
import themeReducer from './reducers/ThemeReducer'
import osReducer from './reducers/OsReducer'
import appVersionReducer from './reducers/AppVersionReducer'
import userSettingsReducer from './reducers/UserSettingsReducer'

export default function createStore() {
  const store = reduxCreateStore(
    combineReducers({
      delayCertificateReducer,
      announcementReducer,
      trainPositionReducer,
      stationReducer,
      stationViewReducer,
      themeReducer,
      osReducer,
      appVersionReducer,
      userSettingsReducer,
    }),
    applyMiddleware(
      ...middlewares
    )
  )
  return store
}
